import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 3F6D9697-9536-4D51-87D3-839E7579451B
 * name clock-time-two
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-two.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeTwoIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11V7H12.5V11.3L16.2 9.2L17 10.5L12.5 13Z" /></>, 'ClockTimeTwoIcon');
export default ClockTimeTwoIcon